@import "../../global/gx-ide-common.scss";

:host {
  display: block;
}
section {
  border-top: 1px solid #ccc;
  margin-top: 300px;
  container-name: section;
  container-type: inline-size;
}
gxg-combo-box {
  opacity: 1;
}
@container section (width < 400px) {
  gxg-combo-box {
    opacity: 0.5;
  }
}
